export default __webpack_public_path__ + "static/media/alert_neighbors.6e2b2a78.svg";